import { SelectNormalIcons } from "../SetupWidget/SelectWidgetIcon";
import MultiSelectBtn from "./multiSelectBtn";
import { useGetDeviceType } from "../../../api/userInfo";
import { useEffect, useState } from "react";
import { InputWithLabel } from "src/components/ui/inputFields/input-with-label";

/*
setup fields for single field widget (don't have multiple fields)
- Performance Device Listed
*/
export const WidgetTitleTypeSetup = ({clearForm, submitForm,widgetDetails, updateWidgetTitle, updateSetupDetails, setupDetails}) => {
    const {getDeviceType} = useGetDeviceType();
    const [selectedType, setSelectedType] = useState('')
    const [errorMsg, setErrorMsg] = useState('')
    const [widgetTitle, setWidgetTitle] = useState('')
    
    const onInput = (field) => (e) => {
        if(field === 'title'){
            updateWidgetTitle(e.target.value)
            setWidgetTitle(e.target.value)
        }else{
            updateSetupDetails({
                ...setupDetails,
                [field]: e.target.value
              });
        }
        //for the controlled input
        if(field === 'type'){
            setSelectedType(e.target.value)
        }
    };

    const handleSubmit = () => {
        if(widgetTitle && selectedType && setupDetails?.icon){
            submitForm()
        }else{
            setErrorMsg('Please fill all fields!')
            setTimeout(() => {
                setErrorMsg('')
            }, 5000);
        }
    }

    useEffect(() => {
        if(widgetDetails){
            updateSetupDetails(widgetDetails?.setup)
            setSelectedType(widgetDetails?.setup?.type)
        }
    }, []);
    
    return ( 
        <>
            {errorMsg && <span className="text-sm font-bold text-red-400">{errorMsg}</span>}
            <div className="grid items-center grid-cols-4 gap-3 mt-4 mb-4">
                <InputWithLabel label="Title" placeholder="Title of widget" name="title" required className="col-span-2"
                    onChange={onInput('title')} defaultValue={widgetDetails?.title}
                    />

                <div className="w-full col-span-2">
                    <label htmlFor="field" className="text-sm text-gray-500 ">Device Type - {selectedType}</label>
                    <select onChange={onInput('type')} className="setupModal_input" required value={selectedType}>
                        <option value="">Select Device Type</option>
                        {getDeviceType?.map((device, index) => (
                            <option key={device?.name} value={device?.name}>{device?.name} - {device?.description}</option>
                        ))}
                    </select>
                </div>
            </div>
                
                
                    <SelectNormalIcons updateSetupDetails={updateSetupDetails} 
                    setupDetails={setupDetails}
                    defaultIcon={widgetDetails?.setup?.icon}
                    
                    /> 
                
                
                {/* ------------ submit button */}
                <div className='flex flex-row justify-between gap-4 mt-4'>
                <button  type="button" onClick={()=> clearForm()} className='w-1/2 py-2 text-center border border-gray-300 rounded-md text-vekin hover:shadow-md'>
                    Cancel
                </button>

                
                    <button type="button" onClick={()=> handleSubmit()}  className='w-1/2 py-2 text-center text-white rounded-md bg-vekin hover:shadow-md'>
                        Submit
                    </button>  

                
                </div>
        </>
     );
}


 

